import { render } from "./GenAISentenceMatching.vue?vue&type=template&id=123e394e"
import script from "./GenAISentenceMatching.vue?vue&type=script&lang=js"
export * from "./GenAISentenceMatching.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__